"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const SportsConfig_1 = require("../../lib/sports/SportsConfig");
const getCurrentPeriod_1 = require("../../util/summary/getCurrentPeriod");
const camelcase_1 = tslib_1.__importDefault(require("camelcase"));
const regularOnlyFilter = (period) => period.type === 'regular';
const overtimeOnlyFilter = (period) => period.type === 'overtime';
const liveOnlyFilter = (period) => period.status === 'live';
exports.getPeriodStartMins = (sportName, periods, currentPeriodCode, matchConfig) => {
    const currentPeriod = getCurrentPeriod_1.getCurrentPeriod(currentPeriodCode, periods);
    if (SportsConfig_1.sportsConfig[camelcase_1.default(sportName)].clock.direction === 'down') {
        if (currentPeriod.type === 'regular') {
            return matchConfig.regularPeriodLength;
        }
        return matchConfig.extratimePeriodLength;
    }
    const livePeriods = periods.filter(liveOnlyFilter);
    const regularPeriods = currentPeriod.type === 'overtime'
        ? livePeriods.filter(regularOnlyFilter).length
        : livePeriods
            .filter(({ status }) => status === 'live')
            .reduce(([total, found], { code }) => {
            if (found) {
                return [total, true];
            }
            // @ts-ignore
            if (code === currentPeriod.code) {
                return [total + 1, true];
            }
            return [total + 1, false];
        }, [0, false])[0];
    const overtimePeriods = currentPeriod.type === 'regular'
        ? 0
        : livePeriods.filter(overtimeOnlyFilter).reduce(([total, found], { code }) => {
            if (found) {
                return [total, true];
            }
            // @ts-ignore
            if (code === currentPeriod.code) {
                return [total + 1, true];
            }
            return [total + 1, false];
        }, [0, false])[0];
    if (overtimePeriods) {
        return (regularPeriods * matchConfig.regularPeriodLength +
            (overtimePeriods - 1) * (matchConfig.extratimePeriodLength || 0));
    }
    if (regularPeriods) {
        return (regularPeriods - 1) * matchConfig.regularPeriodLength;
    }
    return 0;
};
//# sourceMappingURL=getPeriodStartMins.js.map